import { createActionType, createRequestActionTypes } from '../../helpers'

export const UPDATE_PHONE_ID = createActionType('APP', 'UPDATE_PHONE_ID')
export const UPDATE_PRESALE_FLAG = createActionType(
  'APP',
  'UPDATE_PRESALE_FLAG'
)
export const FETCH_CUSTOMER = createRequestActionTypes('APP', 'FETCH_CUSTOMER')
export const SWAP_LANGUAGE = createActionType('APP', 'CHANGE_LANGUAGE')
export const FETCH_OPTIONS = createRequestActionTypes('APP', 'OPTIONS')
export const CLEAR_CONTENT = createActionType('APP', 'CLEAR_CONTENT')



// WEBPACK FOOTER //
// ./src/containers/App/constants.js